import { axios } from '@Root/API'

export const financeRecords = id => {
	return axios.put(`data-pruning-finance/${id}`)
}
